import sms from "@/components/sms";
import QrCode from "qrcode";
import requestApi from "@/utils/requestApi";

export default {
  name: "buyer_dialog",
  components: {
    "n-sms": sms,
  },
  props: {},
  data() {
    return {
      env: process.env,
      orderId: "",
      orderDeliveryForm: {},
      smsVisible: false,

      deliveryDialogVisible: false,
      deliveryGoodsButton: {},
      voucherPicList: [],
      voucherPicNum: 0,
      delivery: 1,

      refLoanDialogVisible: false,
      signatureDialogVisible: false,
      editReceiveDialogVisible: false,
      editMultipleReceiveDialogVisible: false,
      deliveryCauseTypeList: [
        {
          value: "路途损耗",
          text: "路途损耗",
        },
        {
          value: "协商一致",
          text: "协商一致",
        },
      ],

      // 修改收货地址
      deliveryAddr: "",
      deliveryName: "",
      deliveryTel: "",
      deliveryId: "",
      shopDeliveryList: [],
      memberDeliveryList: [],
      eidtDeliveryDialogVisible: false,
      eidtSelfPickupDeliveryDialogVisible: false,
      innerDeliveryVisible: false,
      innerSelfPickupDeliveryVisible: false,
      innerDelivery: {
        loanDeliveryCheck: false,
        deliveryId: "",
        deliveryAddr: "",
        deliveryName: "",
        deliveryTel: "",
        orderInfo: {},
        orderTransportDtl: "",
      },
      thisEditDelivery: {},
      thisEditDeliveryOrderId: "",
      deliveryCheckType: "1", // 1配送 2自提
    };
  },
  methods: {
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      return value;
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isVerify2 = /(zip)/.test(type);
      let isLt3M = size / 1024 / 1024 < 50;
      let sizeErr = "上传大小不能超过 50MB";
      if (isVerify2) {
        sizeErr = "上传大小不能超过 50MB";
        isLt3M = size / 1024 / 1024 < 50;
      }
      if (!isVerify && !isVerify2) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/ZIP/格式");
      } else if (!isLt3M) {
        this.$message.error(sizeErr);
      }
      return (isVerify || isVerify2) && isLt3M;
    },
    // 上传图片成功之后
    uploadVoucherSuccess(res) {
      console.log("上传图片成功之后", res);
      let {
        data: { name, url },
      } = res;
      const isZip = /(zip)$/.test(name);
      if (isZip) {
        url = "https://files.nxin.com/mobile/public/zip.png";
      }
      const item = {
        name: name || "",
        url: url || "",
      };
      this.voucherPicList.push(item);
    },
    // 删除图片
    uploadVoucherRemove(file, fileList) {
      this.voucherPicList = fileList;
    },
    // 上传图片限制
    uploadVoucherExceed() {
      this.$message.warning("最多上传30张图片");
    },
    toDeliveryGoodsOpen(item, voucherPicNum, buyerVoucherPicList, delivery) {
      this.deliveryGoodsButton = item;
      this.voucherPicNum = voucherPicNum;
      this.voucherPicList = buyerVoucherPicList;
      this.delivery = delivery;
      this.deliveryDialogVisible = true;
    },
    // 初始确认收货
    toDeliveryGoodsSubmit() {
      if (this.voucherPicList.length > 0) {
        let orderVoucher = [];
        this.voucherPicList.forEach((item) => {
          let acUrl = item.acUrl;
          let url = item.url;
          if (acUrl) {
            url = acUrl;
          }
          let voucher = {
            fileType: "ORDER_VOUCHER_PICTURE",
            busType: "BUYER",
            refId: this.deliveryGoodsButton.orderId,
            url: url,
          };
          orderVoucher.push(voucher);
        });
        this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderVoucher }).then((res) => {
          console.log("addOrderVoucherList", res);
          if (res.code == "0") {
            this.voucherPicList = [];
          } else {
            this.$message.warning("上传失败");
            return;
          }
        });
      }
      this.$store.dispatch("orderTo/index/selBuildOrderToDelivery", { orderId: this.deliveryGoodsButton.orderId }).then((res) => {
        if (res && res.data) {
          this.orderDeliveryForm = {
            orderId: this.deliveryGoodsButton.orderId,
            loId: "",
            isFinallyReceive: 0,
            receiveNumInfo: {},
            receiveNumInfoList: [],
            deliveryCause: "",
            isCreditPay: res.data.isCreditPay,
            isLoan: res.data.isLoan,
            isSign: res.data.isSign,
            signUrl: res.data.signUrl,
            boId: res.data.boId,
            orgBoId: res.data.orgBoId,
            phone: res.data.phone,
            captchaCode: "",
            thisReceiveNumInfoIndex: "",
            thisReceiveNumInfo: "",
            loanCheck: false,
            isMultipleDeliver: res.data.isMultipleDeliver,
            isSupportEditReceiveNum: res.data.isSupportEditReceiveNum,
          };
          if (this.delivery == 2) {
            this.receipt_order_goods();
            return;
          }
          if (this.orderDeliveryForm.isMultipleDeliver == 1) {
            //多次发货多次确认收货
            this.$store.dispatch("orderTo/index/queryOrderDeliveryList", { orderId: this.orderDeliveryForm.orderId }).then((res) => {
              this.orderDeliveryForm.receiveNumInfoList = res.data.orderDeliveryList;
              this.orderDeliveryForm.receiveNumInfoList.forEach((item, index) => {
                this.$set(this.orderDeliveryForm.receiveNumInfoList[index], "deliveyNum", item.goodsQuantity);
                this.$set(this.orderDeliveryForm.receiveNumInfoList[index], "receivNum", item.goodsQuantity);
                this.$set(this.orderDeliveryForm.receiveNumInfoList[index], "deliveryCause", "路途损耗");
              });
            });
            this.orderDeliveryForm.isFinallyReceive = res.data.isFinallyReceive;
            this.editMultipleReceiveDialogVisible = true;
            this.deliveryDialogVisible = false;
          } else if (this.orderDeliveryForm.isSupportEditReceiveNum == 1) {
            //收货填写收货数量
            this.$store.dispatch("orderTo/index/queryOrderDeliveryList", { orderId: this.orderDeliveryForm.orderId }).then((res) => {
              // 弹出窗口--收货时填写确认收货数量
              this.orderDeliveryForm.receiveNumInfoList = res.data.orderDeliveryList;
              this.orderDeliveryForm.receiveNumInfoList.forEach((item, index) => {
                this.$set(this.orderDeliveryForm.receiveNumInfoList[index], "deliveyNum", item.goodsQuantity);
                this.$set(this.orderDeliveryForm.receiveNumInfoList[index], "receivNum", item.goodsQuantity);
              });
            });
            this.orderDeliveryForm.deliveryCause = "路途损耗";
            this.orderDeliveryForm.isFinallyReceive = 1;
            this.editReceiveDialogVisible = true;
            this.deliveryDialogVisible = false;
          } else {
            this.receipt_order_goods();
            this.deliveryDialogVisible = false;
          }
        } else {
          this.$message.warning("确认收货失败");
        }
      });
    },
    multipleReceiveGoods(thisReceiveNumInfoIndex) {
      if (thisReceiveNumInfoIndex == -1) {
        this.orderDeliveryForm.receiveNumInfoList.forEach((item) => {
          this.orderDeliveryForm.receiveNumInfo[item.orderGoodsId] = item.goodsQuantity;
        });
      } else {
        let orderGoodsId = this.orderDeliveryForm.receiveNumInfoList[thisReceiveNumInfoIndex].orderGoodsId;
        this.orderDeliveryForm.receiveNumInfo[orderGoodsId] = this.orderDeliveryForm.receiveNumInfoList[thisReceiveNumInfoIndex].receivNum;
        this.orderDeliveryForm.deliveryCause = this.orderDeliveryForm.receiveNumInfoList[thisReceiveNumInfoIndex].deliveryCause;
        this.orderDeliveryForm.loId = this.orderDeliveryForm.receiveNumInfoList[thisReceiveNumInfoIndex].loId;
      }
      this.orderDeliveryForm.thisReceiveNumInfo = JSON.stringify(this.orderDeliveryForm.receiveNumInfo);
      this.editReceiveDialogVisible = false;
      this.editMultipleReceiveDialogVisible = false;
      if (this.orderDeliveryForm.isFinallyReceive == 1) {
        this.receipt_order_goods();
      } else {
        this.$store
          .dispatch("orderTo/index/receiptOrderGoods", {
            deliveryCause: this.orderDeliveryForm.deliveryCause,
            receiveNumInfo: this.orderDeliveryForm.thisReceiveNumInfo,
            orderId: this.orderDeliveryForm.orderId,
            loId: this.orderDeliveryForm.loId,
          })
          .then((res) => {
            if (res.result) {
              this.refLoanDialogVisible = false;
              this.signatureDialogVisible = false;
              this.editReceiveDialogVisible = false;
              this.editMultipleReceiveDialogVisible = false;
              this.deliveryDialogVisible = false;
              this.smsVisible = false;
              this.$message("收货成功！");
              this.$emit("loadOrder");
            } else {
              this.$message.warning(res.msg);
            }
          });
      }
    },
    receipt_order_goods() {
      if (this.orderDeliveryForm.isCreditPay) {
        this.editReceiveDialogVisible = false;
        this.editMultipleReceiveDialogVisible = false;
        this.deliveryDialogVisible = false;
        this.smsVisible = true;
      } else {
        this.callSettlementBusiness();
      }
    },
    isLoanSubmit() {
      if (this.orderDeliveryForm.isLoan) {
        this.editReceiveDialogVisible = false;
        this.editMultipleReceiveDialogVisible = false;
        this.deliveryDialogVisible = false;
        this.refLoanDialogVisible = true;
      } else {
        this.callSettlementBusiness();
      }
    },
    readConfirmSee() {
      const personId = this.orderDeliveryForm.orgBoId != "0" ? this.orderDeliveryForm.orgBoId : this.orderDeliveryForm.boId;
      window.open(`${process.env.VUE_APP_APP}order/person/debtConfirmSee.do?orderId=${this.orderDeliveryForm.orderId}&boId=${personId}`);
      // this.$store
      //   .dispatch("orderTo/index/toConfirmSee", {
      //     orderNum: this.orderDeliveryForm.orderId,
      //     personId: this.orderDeliveryForm.orgBoId != "0" ? this.orderDeliveryForm.orgBoId : this.orderDeliveryForm.boId,
      //     signNum: this.orderDeliveryForm.signNum,
      //     debtConfirmSeeUrl: this.orderDeliveryForm.debtConfirmSeeUrl,
      //   })
      //   .then(() => {});
    },

    loanSubmit() {
      if (!this.orderDeliveryForm.loanCheck) {
        this.$message.warning("请查看《债务确认书》的内容");
        return;
      }
      this.$store
        .dispatch("orderTo/index/requestDebtConfirm", {
          orderId: this.orderDeliveryForm.orderId,
          boId: this.orderDeliveryForm.boId,
        })
        .then((res) => {
          if (res.ret == 0) {
            this.callSettlementBusiness();
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    callSettlementBusiness() {
      if (this.orderDeliveryForm.isSign == 1) {
        this.editReceiveDialogVisible = false;
        this.editMultipleReceiveDialogVisible = false;
        this.deliveryDialogVisible = false;
        this.smsVisible = false;
        this.signatureDialogVisible = true;
        setTimeout(() => {
          QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_APP}${this.orderDeliveryForm.signUrl}&returnUrl=${window.location.href}`);
        }, 1000);
        return;
      }
      this.$store
        .dispatch("orderTo/index/receiptOrderGoods", {
          deliveryCause: this.orderDeliveryForm.deliveryCause,
          receiveNumInfo: this.orderDeliveryForm.thisReceiveNumInfo,
          orderId: this.orderDeliveryForm.orderId,
          loId: this.orderDeliveryForm.loId,
        })
        .then((res) => {
          if (res.result) {
            this.refLoanDialogVisible = false;
            this.signatureDialogVisible = false;
            this.editReceiveDialogVisible = false;
            this.editMultipleReceiveDialogVisible = false;
            this.deliveryDialogVisible = false;
            this.smsVisible = false;
            this.$message("收货成功！");
            this.$emit("loadOrder");
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    addDelivery() {
      window.open(`${process.env.VUE_APP_APP}v/buyer/receive`);
    },
    refreshDelivery() {
      this.toEditDelivery(this.thisEditDeliveryOrderId);
    },
    toEditDelivery(orderId) {
      this.thisEditDeliveryOrderId = orderId;
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/order/orderdelivery/selDeliveryAddrList`, {
          orderId: orderId,
        })
        .then((res) => {
          if (res.code == "0") {
            this.innerDelivery.orderTransportDtl = res.data.orderTransportDtl;
            this.deliveryAddr = res.data.orderTransportDtl.addr;
            this.deliveryName = res.data.orderTransportDtl.linkman;
            this.deliveryTel = res.data.orderTransportDtl.tel;
            this.deliveryId = res.data.orderTransportDtl.deliveryId;
            this.memberDeliveryList = res.data.memberDeliveryList || [];
            this.innerDelivery.orderInfo = res.data.orderInfo;
            this.innerDelivery.deliveryId = "";
            this.innerDelivery.deliveryName = "";
            this.innerDelivery.deliveryTel = "";
            this.innerDelivery.deliveryAddr = "";
            this.thisEditDelivery = {};
            this.eidtDeliveryDialogVisible = true;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("查询失败");
        });
    },

    toEditSelfPickupDelivery(orderId) {
      this.thisEditDeliveryOrderId = orderId;
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/order/orderdelivery/selDeliveryAddrList`, {
          orderId: orderId,
        })
        .then((res) => {
          if (res.code == "0") {
            this.innerDelivery.orderTransportDtl = res.data.orderTransportDtl;
            this.deliveryAddr = res.data.orderTransportDtl.addr;
            this.deliveryName = res.data.orderTransportDtl.linkman;
            this.deliveryTel = res.data.orderTransportDtl.tel;
            this.deliveryId = res.data.orderTransportDtl.deliveryId;
            this.innerDelivery.orderInfo = res.data.orderInfo;
            this.shopDeliveryList = res.data.shopDeliveryList || [];
            this.innerDelivery.deliveryId = "";
            this.innerDelivery.deliveryName = "";
            this.innerDelivery.deliveryTel = "";
            this.innerDelivery.deliveryAddr = "";
            this.eidtSelfPickupDeliveryDialogVisible = true;
            this.thisEditDelivery = {};
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("查询失败");
        });
    },
    thisEditDeliveryCheck(item) {
      this.thisEditDelivery = item;
      console.log("this.thisEditDelivery", this.thisEditDelivery);
      this.innerDelivery.deliveryId = this.thisEditDelivery.deliveryId;
      this.innerDelivery.deliveryName = this.thisEditDelivery.name || "";
      this.innerDelivery.deliveryTel = this.thisEditDelivery.tel || "";
      this.innerDelivery.deliveryAddr = this.thisEditDelivery.allName || "";
    },
    innerDeliveryCheck(deliveryCheckType) {
      if (!this.thisEditDelivery.deliveryId || this.thisEditDelivery.deliveryId == "") {
        this.$message("请选择新的地址");
        return;
      }
      this.deliveryCheckType = deliveryCheckType;
      this.innerDeliveryVisible = true;
    },
    saveDelivery() {
      if (!this.thisEditDelivery.deliveryId || this.thisEditDelivery.deliveryId == "") {
        this.$message("请选择新的地址");
        return;
      }
      if (this.innerDelivery.orderInfo.contractId !== "0" && !this.innerDelivery.loanDeliveryCheck) {
        this.$message("请先同意《订单地址修改协议》");
        return;
      }
      console.log("this.innerDelivery", this.innerDelivery);
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/order/orderdelivery/editOrderDelivery`, {
          orderDeliveryEntity: {
            orderId: this.thisEditDeliveryOrderId,
            orderDeliveryStr: JSON.stringify(this.innerDelivery),
          },
        })
        .then((res) => {
          if (res.code == "0") {
            this.eidtSelfPickupDeliveryDialogVisible = false;
            this.eidtDeliveryDialogVisible = false;
            this.innerDeliveryVisible = false;
            this.$message(res.msg);
            this.$emit("loadOrder");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("修改失败");
        });
    },
  },
};
